<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.number'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.age'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.initialValue'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.depreciation.charges'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.total.depreciation.charges'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.depreciation.charges.currentValue'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.furniture'"></td>
        </tr>
        <tr *ngFor="let furnitureDepreciation of study.furnitureDepreciationList">
            <td></td>
            <td class="_number">
                {{furnitureDepreciation.roomNumber}}
            </td>
            <td class="_number">
                {{furnitureDepreciation.ageInMonths}}
            </td>
            <td class="_number">
                {{furnitureDepreciation.initialValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{furnitureDepreciation.depreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{furnitureDepreciation.totalDepreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{furnitureDepreciation.currentValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="font-bold"[i18nKey]="'common.total1'"></td>
            <td></td>
            <td></td>
            <td class="_number font-bold">{{study.totalFurnitureDepreciation.initialValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number font-bold">{{study.totalFurnitureDepreciation.depreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number font-bold">{{study.totalFurnitureDepreciation.totalDepreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number font-bold">{{study.totalFurnitureDepreciation.currentValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.dining.rooms.layout'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>

        <tr *ngFor="let tablewareDepreciation of study.tablewareDepreciationList">
            <td></td>
            <td class="_number">
                {{tablewareDepreciation.roomNumber}}
            </td>
            <td class="_number">
                {{tablewareDepreciation.ageInMonths}}
            </td>
            <td class="_number">
                {{tablewareDepreciation.initialValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{tablewareDepreciation.depreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{tablewareDepreciation.totalDepreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{tablewareDepreciation.currentValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
        </tr>
        <tr>
            <td class="font-bold"[i18nKey]="'common.total2'"></td>
            <td></td>
            <td></td>
            <td class="font-bold _number">{{study.totalTablewareDepreciation.initialValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalTablewareDepreciation.depreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalTablewareDepreciation.totalDepreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalTablewareDepreciation.currentValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>

        <tr>
            <td class="font-bold"[i18nKey]="'studies.depreciation.charges.totalDepreciation'"></td>
            <td></td>
            <td></td>
            <td class="font-bold _number">{{study.totalDepreciationCharges.initialValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalDepreciationCharges.depreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalDepreciationCharges.totalDepreciation | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="font-bold _number">{{study.totalDepreciationCharges.currentValue | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
        </tr>
        </tbody>
    </table>
</div>
